<div style="display: flex; flex-direction: column; width: 100%; height: 100%">
  @if (isLoading) {
    <div
      style="flex: 1 0 100%; min-height: 0; display: flex; flex-direction: column; justify-content: space-between;">
      @if (selectedWidget === 'instrument' || selectedWidget === 'service-history') {
        <sh-tabs id="maintenance-details-tabs-1" style="width: 43%" condensed [collapsed]="screenSize === 'XSmall' || screenSize === 'Small' || screenSize === 'Medium'"
          >
          @for (tab of displayedTabs; track tab.name) {
            <sh-tab-item id="maintenance-details-tab-item-2" disabled [active]="activeTab === tab.name"
            (click)="switchTab(tab.name)" [attr.label]="tab.labelKey | transloco"></sh-tab-item>
          }
        </sh-tabs>
      }
      <div style="flex: 1; display: flex; align-items: center; justify-content: center;">
        <sh-spinner id="maintenance-details-spinner-3" site="s"></sh-spinner>
      </div>
    </div>
  }
  <sh-tooltip id="maintenance-details-tooltip-4" #tooltip></sh-tooltip>
  @if (!isLoading && maintenance) {
    <div style="flex: 1; min-height: 0;">
      @if (maintenance && !isLoading) {
        <p-table [size]="'small'" #table [value]="maintenance" dataKey="routine_name"
          [scrollable]="true" [scrollHeight]="'flex'" [customSort]="true" (sortFunction)="customSort($event)"
          [sortField]="'failed'" [sortOrder]="-1">
          <!-- Tools -->
          <ng-template #caption style="border: none;">
            <div style="display: flex; align-items: center; gap: 64px;">
              @if (selectedWidget === 'instrument' || selectedWidget === 'service-history') {
                <sh-tabs id="maintenance-details-tabs-5" style="flex: 1 1 43%;" condensed [collapsed]="screenSize === 'XSmall' || screenSize === 'Small' || screenSize === 'Medium'"
                  >
                  @for (tab of displayedTabs; track tab.name) {
                    <sh-tab-item id="maintenance-details-tab-item-6" [active]="activeTab === tab.name"
                    (click)="switchTab(tab.name)" [attr.label]="tab.labelKey | transloco"></sh-tab-item>
                  }
                </sh-tabs>
              }
              <div class="table-tools" style="flex: 1 1 57%; gap: 8px; align-items: center;">
                <sh-dropdown id="maintenance-details-dropdown-7" no-border condensed style="min-width: 100px; max-width: 140px;">
                  <sh-menu-item id="maintenance-details-menu-item-7-days" (click)="changeRange(7,'systemHealth')" [attr.label]="'errors.range.7days' | transloco"
                  [active]="selectedRange === 7"></sh-menu-item>
                  <sh-menu-item id="maintenance-details-menu-item-14-days" (click)="changeRange(14,'systemHealth')" [attr.label]="'errors.range.14days' | transloco"
                  [active]="selectedRange === 14"></sh-menu-item>
                  <sh-menu-item id="maintenance-details-menu-item-30-days" (click)="changeRange(30,'systemHealth')" [attr.label]="'errors.range.30days' | transloco"
                  [active]="selectedRange === 30"></sh-menu-item>
                </sh-dropdown>
                <p-columnFilter style="min-width: 150px;" type="text" [showMenu]="false" field="routine_name"
                  matchMode="contains">
                  <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                    <sh-search id="maintenance-details-search-search-for-routine" no-border [attr.label]="'maintenanceDetails.filter.searchForRoutine' | transloco" condensed [(ngModel)]="searchTerm"
                    (ngModelChange)="filter($event)"></sh-search>
                  </ng-template>
                </p-columnFilter>
                <sh-divider id="maintenance-details-divider-12" spacing='s' style="height: 30px;" vertical></sh-divider>
                <!-- <sh-button id="maintenance-details-button-all-charts" layout="compact" icon="analytics" icon-position="left" color="secondary"
              label="All Charts" (click)="openCharts()"></sh-button> -->
              <sh-icon id="maintenance-details-icon-analytics" icon="analytics" size="s" (click)="openCharts()" (mouseover)="showTooltip('maintenanceDetails.tooltip.allCharts', $event)" button></sh-icon>
              <sh-divider id="maintenance-details-divider-15" spacing='s' style="height: 30px;" vertical></sh-divider>
              <sh-icon id="maintenance-details-icon-16" button icon='refresh' size="s" (click)="refresh()"></sh-icon>
              @if (workareaSize !== 'fullscreen') {
                <sh-icon id="maintenance-details-icon-17" size="xs" [icon]="workareaSize === 'medium' ? 'arrow-face-up-l' : 'arrow-face-down-l'"
                button (click)="onMaximize()" [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
              }
              <sh-icon id="maintenance-details-icon-expand" size="s" [icon]="workareaSize === 'fullscreen' ? 'split-vertically' : 'maximize'" button (click)="onExpand($event)"
              [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
              <sh-icon id="maintenance-details-icon-cancel" icon="cancel" size="s" button (click)="onMinimize()"
              [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
            </div>
          </div>
        </ng-template>
        <!-- Table Header -->
        <ng-template pTemplate="header">
          <tr>
            <th pFrozenColumn pSortableColumn="routine_name" style="min-width: 300px;">
              <div style="display: flex; align-items: center; gap: 6px;">{{ 'maintenanceDetails.table.routine' | transloco }}<p-sortIcon
                field="routine_name" />
            </div>
          </th>
          <th pSortableColumn="failed" style="min-width: 175px; text-align: right;">
            <div style="display: flex; align-items: center; gap: 6px; justify-content: flex-end;">{{ 'maintenanceDetails.table.failedAndTrend' | transloco }}<p-sortIcon field="failed" />
            </div>
          </th>
          <th pSortableColumn="not_performed" style="min-width: 150px; text-align: right;">
            <div style="display: flex; align-items: center; gap: 6px; justify-content: flex-end;">{{ 'maintenanceDetails.table.notPerformed' | transloco }}<p-sortIcon field="not_performed" />
            </div>
          </th>
          <th pSortableColumn="not_performed_without_comment" style="min-width: 150px; text-align: right;">
            <div style="display: flex; align-items: center; gap: 6px; justify-content: flex-end;">{{ 'maintenanceDetails.table.notPerformedNoComment' | transloco }}<p-sortIcon field="not_performed_without_comment" />
            </div>
          </th>
          <th pSortableColumn="succeeded" style="min-width: 130px; text-align: right;">
            <div style="display: flex; align-items: center; gap: 6px; justify-content: flex-end;">
              {{ 'maintenanceDetails.table.succeeded' | transloco }}<p-sortIcon field="succeeded" />
            </div>
          </th>
          <th pSortableColumn="last_failed_date" style="min-width: 150px; ">
            <div style="display: flex; align-items: center; gap: 6px; justify-content: flex-end;">{{ 'maintenanceDetails.table.lastFailed' | transloco }}<p-sortIcon field="last_failed_date" />
            </div>
          </th>
          <th style="min-width: 0px; text-align: center;" alignFrozen="right" pFrozenColumn>{{ 'maintenanceDetails.table.actions' | transloco }}</th>
        </tr>
      </ng-template>
      <!-- Rows -->
      <ng-template pTemplate="body" let-row let-expanded="expanded">
        <tr>
          <td pFrozenColumn>
            <div style="display: flex; align-items: center; gap: 8px; width: 100%;">
              <b><span [innerHTML]="highlight(row.routine_name)"></span></b>
            </div>
          </td>
          <td style="text-align: right;">
            <div style="display: flex; justify-content: flex-end; align-items: center; gap: 8px;">
              @if (hasNonZeroTrend(row['metrics'][''+selectedRange]['trend'])) {
                <canvas baseChart class="tableChart" type="line"
                  [data]="chartConfigs[row.routine_name]?.data"
                  [options]="chartConfigs[row.routine_name]?.options">
                </canvas>
              }
              @if (row['metrics'][''+selectedRange]['failed'] > 0) {
                <sh-badge id="maintenance-details-badge-true" type='warning'
                  size="medium" show-label="true"
                [label]="row['metrics'][''+selectedRange]['failed'] + ''"></sh-badge>
              }
              @if (row['metrics'][''+selectedRange]['failed'] === 0) {
                <span>-</span>
              }
            </div>
          </td>
          <td style="text-align: right;">
            <div style="display: flex; justify-content: flex-end; align-items: center;">
              @if (row['metrics'][''+selectedRange]['not_performed'] > 0) {
                <sh-badge id="maintenance-details-badge-true" type='warning'
                  size="medium" show-label="true"
                  [label]="row['metrics'][''+selectedRange]['not_performed'] + ''"
                style="background-color: var(--success-icon-color) !important"></sh-badge>
              }
              @if (row['metrics'][''+selectedRange]['not_performed'] === 0) {
                <span>-</span>
              }
            </div>
          </td>
          <td style="text-align: right;">
            <div style="display: flex; justify-content: flex-end; align-items: center;">
              @if (row['metrics'][''+selectedRange]['not_performed_without_comment'] > 0) {
                <sh-badge id="maintenance-details-badge-true"
                  type='warning' size="medium" show-label="true"
                  [label]="row['metrics'][''+selectedRange]['not_performed_without_comment'] + ''"
                style="background-color: var(--success-icon-color) !important"></sh-badge>
              }
              @if (row['metrics'][''+selectedRange]['not_performed_without_comment'] === 0) {
                <span
                >-</span>
              }
            </div>
          </td>
          <td>
            <div style="display: flex; justify-content: flex-end; align-items: center;">
              @if (row['metrics'][''+selectedRange]['succeeded'] > 0) {
                <sh-badge id="maintenance-details-badge-true" type='success'
                  size="medium" show-label="true"
                [label]="row['metrics'][''+selectedRange]['succeeded'] + ''"></sh-badge>
              }
              @if (row['metrics'][''+selectedRange]['succeeded'] === 0) {
                <span>-</span>
              }
            </div>
          </td>
          <td style="text-align: right;">{{row['last_failed_date']}}</td>
          <td alignFrozen="right" pFrozenColumn>
            <div style="display: flex; gap: 8px; justify-content: flex-end; align-items: center;">
              @if (row['metrics'][''+selectedRange]['failed'] > 0) {
                <sh-button id="maintenance-details-button-failure-details" layout="compact" color="tertiary" [attr.label]="'maintenanceDetails.button.failureDetails' | transloco"
                (click)="openFailureModal(row, $event)"></sh-button>
              }
              @if (row['metrics'][''+selectedRange]['failed'] > 0) {
                <sh-button id="maintenance-details-button-fix" icon-position="left"
                  icon="ai-generative" [ngClass]="'magic-button'" compact [attr.label]="'maintenanceDetails.button.fix' | transloco" size="s"
                color="tertiary" (click)="askChat(row.routine_name)"></sh-button>
              }
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7">
            @if (!isError) {
              <div
                style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                <sh-icon id="maintenance-details-icon-warning" icon="warning" size="s"></sh-icon>
                <span>{{ 'common.empty.noData' | transloco }}</span>
              </div>
            }
            @if (isError) {
              <div
                style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                <sh-icon id="maintenance-details-icon-error" icon="error" size="s"></sh-icon>
                <span>{{ 'common.empty.error' | transloco }}</span>
              </div>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
}

</div>